import { RefObject, useEffect, useState } from 'react';
import { useIntersectionObserver } from '@fiverr-private/hooks';

/**
 * Calls `onEnteredView` callback once when element is in view.
 * The callback is called again when `onEnteredView` ref changes and element is in view again.
 * @param ref - element ref
 * @param onEnteredView - callback
 */
export const useEnteredViewOnce = (
    ref: RefObject<HTMLElement>,
    onEnteredView: () => void
) => {
    const [cbCalled, setCbCalled] = useState(false);

    const entry = useIntersectionObserver(ref, {
        threshold: 0.5,
    });

    const entered = !!entry?.isIntersecting;

    useEffect(() => {
        setCbCalled(false);
    }, [onEnteredView]);

    useEffect(() => {
        if (entered && !cbCalled) {
            onEnteredView();
            setCbCalled(true);
        }
    }, [entered, cbCalled, onEnteredView]);
};
